let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lKWyW")).then(() => parcelRequire('4dfVD'));